import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=3159d182&scoped=true&"
import script from "./SupplierInfo.vue?vue&type=script&lang=ts&"
export * from "./SupplierInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=3159d182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159d182",
  null
  
)

export default component.exports